/**
 * Zod without its JIT.
 *
 * Zod 4 compiles object parsers with `new Function` when it may, and finds out
 * by trying one the first time a `z.object()` is built. The CSP in
 * public/_headers has no 'unsafe-eval', so that attempt throws, Zod falls back
 * to its plain parser, and the browser logs a CSP violation on every start.
 * `jitless` skips the attempt and leaves the same parser the CSP already
 * forced.
 *
 * main.tsx imports this first: schemas built at module load (wflash-importer,
 * csv-parser…) check the setting when they are created.
 */
import { z } from 'zod'

z.config({ jitless: true })
